import {
  PRINT_TEMPLATE_LOADING,
  GET_PRINT_TEMPLATE,
  GET_PRINT_TEMPLATE_SUCCESS,
  GET_PRINT_TEMPLATE_FAIL,
  ADD_PRINT_TEMPLATE_SUCCESS,
  ADD_PRINT_TEMPLATE_FAIL,
  DELETE_PRINT_TEMPLATE_SUCCESS,
  DELETE_PRINT_TEMPLATE_FAIL,
  UPDATE_PRINT_TEMPLATE_SUCCESS,
  UPDATE_PRINT_TEMPLATE_FAIL,
  PRINT_TEMPLATE_RESET
} from "./actionType";

const INIT_STATE = {
  printTemplates: [],
  error: {},
};

const PrintTemplate = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRINT_TEMPLATE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRINT_TEMPLATE:
          return {
            ...state,
            printTemplates: action.payload.data,
            isPrintTemplateCreated: false,
            isPrintTemplateSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRINT_TEMPLATE_FAIL:
      switch (action.payload.actionType) {
        case GET_PRINT_TEMPLATE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPrintTemplateCreated: false,
            isPrintTemplateSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRINT_TEMPLATE: {
      return {
        ...state,
        isPrintTemplateCreated: false,
        loading: true,
      };
    }

    case PRINT_TEMPLATE_LOADING: {
      return {
        ...state,
        isPrintTemplateCreated: false,
        loading: true,
      };
    }

    case ADD_PRINT_TEMPLATE_SUCCESS:
      return {
        ...state,
        isPrintTemplateCreated: true,
        loading: false,
        printTemplates: [action.payload.data, ...state.printTemplates],
      };

    case ADD_PRINT_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRINT_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        printTemplates: state.printTemplates.filter(
          printTemplate => printTemplate.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRINT_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRINT_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        printTemplates: state.printTemplates.map(printTemplate =>
          printTemplate.id.toString() === action.payload.data.id.toString() ? { ...printTemplate, ...action.payload.data } : printTemplate
        ),
      };

    case UPDATE_PRINT_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRINT_TEMPLATE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PrintTemplate;